import React, { useState, useEffect } from 'react';
import { PlusIcon, TrashIcon, PencilIcon } from '@heroicons/react/24/outline';

export default function TablaEstrategias({
    estrategias,
    loading,
    onAgregar,
    onEditar,
    onEliminar,
    onSeleccionar,
    estrategiaSeleccionada
}) {

    const formatearFecha = (fecha) => {
        if (!fecha) return '';
        // Si es una fecha ISO, extraer solo la fecha
        const dateStr = typeof fecha === 'string' ? fecha.split('T')[0] : fecha;
        const date = new Date(dateStr);
        return new Intl.DateTimeFormat('es-ES', { year: 'numeric', month: 'long' }).format(date);
    };

    return (
        <div className="bg-white rounded-2xl shadow-2xl overflow-hidden border border-gray-100">
            {/* Header */}
            <div className="bg-gradient-to-r from-blue-700 via-blue-600 to-cyan-500 px-6 py-5 flex items-center justify-between">
                <div className="flex items-center gap-3">
                    <div className="p-2 bg-white/20 rounded-lg">
                        <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                        </svg>
                    </div>
                    <div>
                        <h2 className="text-lg font-black text-white">Estrategias</h2>
                        <p className="text-blue-100 text-xs">{estrategias.length} configuradas</p>
                    </div>
                </div>
                <button
                    onClick={onAgregar}
                    className="px-3 py-2 bg-white/20 hover:bg-white/30 text-white font-bold rounded-lg transition-colors flex items-center gap-2 text-sm"
                >
                    <PlusIcon className="w-4 h-4" />
                    Agregar
                </button>
            </div>

            {/* Content */}
            {loading ? (
                <div className="p-12 text-center">
                    <div className="inline-block">
                        <div className="animate-spin rounded-full h-12 w-12 border-4 border-blue-200 border-t-blue-600"></div>
                    </div>
                    <p className="mt-4 text-gray-600 font-semibold">Cargando estrategias...</p>
                </div>
            ) : estrategias.length === 0 ? (
                <div className="p-12 text-center">
                    <div className="text-5xl mb-4">📊</div>
                    <h3 className="text-lg font-bold text-gray-700">Sin estrategias</h3>
                    <p className="text-gray-500 mt-2 text-sm">Crea tu primera estrategia para comenzar</p>
                </div>
            ) : (
                <div className="overflow-y-auto max-h-[calc(100vh-280px)]">
                    <div className="space-y-3 p-4">
                        {estrategias.map((item) => (
                            <div
                                key={item.idCbo_FlujoDeCobranzas}
                                onClick={() => onSeleccionar(item)}
                                className={`p-4 rounded-xl cursor-pointer transition-all transform hover:scale-105 border-2 ${
                                    estrategiaSeleccionada?.idCbo_FlujoDeCobranzas === item.idCbo_FlujoDeCobranzas
                                        ? 'bg-gradient-to-r from-blue-50 to-cyan-50 border-blue-500 shadow-lg ring-2 ring-blue-300'
                                        : 'bg-gray-50 border-gray-200 hover:border-blue-300'
                                }`}
                            >
                                <div className="flex items-start justify-between mb-3">
                                    <div className="flex-1">
                                        <p className="font-black text-gray-900 text-sm uppercase">{formatearFecha(item.Periodo)}</p>
                                    </div>
                                    {item.cbo_Riesgo && (
                                        <span className={`px-2 py-1 rounded-full text-xs font-bold whitespace-nowrap ml-2 ${
                                            item.cbo_Riesgo.Riesgo === 'Alto' 
                                                ? 'bg-red-100 text-red-700'
                                                : item.cbo_Riesgo.Riesgo === 'Medio'
                                                ? 'bg-yellow-100 text-yellow-700'
                                                : 'bg-green-100 text-green-700'
                                        }`}>
                                            {item.cbo_Riesgo.Riesgo}
                                        </span>
                                    )}
                                </div>
                                
                                <div className="bg-white rounded-lg p-3 mb-3 border border-gray-200">
                                    {item.cbo_ResultadoGestion && (
                                        <p className="text-xs text-gray-600 mb-1">
                                            <span className="font-semibold text-gray-700">Gestión:</span> {item.cbo_ResultadoGestion.Resultado}
                                        </p>
                                    )}
                                    {item.cbo_TipoCartera && (
                                        <p className="text-xs text-gray-600">
                                            <span className="font-semibold text-gray-700">Cartera:</span> {item.cbo_TipoCartera.Cartera}
                                        </p>
                                    )}
                                </div>

                                <div className="flex gap-2">
                                    <button
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            onSeleccionar(item);  // Primero selecciona
                                            onEditar(item);        // Luego abre para editar
                                        }}
                                        className="flex-1 p-2 hover:bg-blue-100 rounded-lg transition-colors text-blue-600 hover:text-blue-700 font-bold text-xs"
                                        title="Editar"
                                    >
                                        ✏️ Editar
                                    </button>
                                    <button
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            onEliminar(item.idCbo_FlujoDeCobranzas);
                                        }}
                                        className="flex-1 p-2 hover:bg-red-100 rounded-lg transition-colors text-red-600 hover:text-red-700 font-bold text-xs"
                                        title="Eliminar"
                                    >
                                        🗑️ Eliminar
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
}
